document.addEventListener("alpine:init", () => {
  Alpine.store("modal", {
    // isOpen: Shopify.designMode ? true : false,
    activeModals: {
      DRAWER_MENU: false,
      DRAWER_CART: false,
      DRAWER_SEARCH: false,
      // Add more modals here...
    },

    open(key) {
      // Close all modals first
      Object.keys(this.activeModals).forEach((modal) => {
        this.activeModals[modal] = false;
      });
      // Open the selected modal
      this.activeModals[key] = true;
    },

    close(key) {
      this.activeModals[key] = false;
    },

    toggle(key) {
      // If the modal is open, close it. If it's closed, open it.
      this.activeModals[key] = !this.activeModals[key];
    },

    isOpen(key) {
      return this.activeModals[key];
    },

    watchUrlChanges() {
      document.addEventListener("swup:page:view", () => {
        Object.keys(this.activeModals).forEach((modal) => {
          this.activeModals[modal] = false;
        });
      });
    },
  });

  // Initialize URL watcher
  Alpine.store("modal").watchUrlChanges();
  Alpine.data("recommendations", () => ({
    products: [],

    async fetchRecommendations(productId) {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}`
      );
      const data = await response.json();

      this.products = data.products.map((product) => ({
        id: product.id,
        title: product.title,
        image: product.featured_image?.src,
        url: product.url,
        price: Shopify.formatMoney(product.price, Shopify.money_format),
      }));

      console.log("FETCH =>", data);
    },

    init() {
      const productId =
        document.querySelector("[data-product-id]").dataset.productId;
      if (productId) {
        this.fetchRecommendations(productId);
      }
    },
  }));
});
